import { Link, Outlet, useLoaderData, useLocation, useSearchParams } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import type { Work, WorkListResponse } from "./types";
import UserInfo from "src/components/common/userInfo";
export const extraFields = ["page", "limit"];
export default function Works() {
    const [searchParams] = useSearchParams();
    const { works, total } = useLoaderData() as WorkListResponse;
    const location = useLocation();
    const onFilter = [...searchParams.keys()].some(key => !extraFields.includes(key));

    return (
        <div className={"cssContent" + (total > 0 ? " pb8rem" : "")}>
            <div className="mt-2">
                <Link
                    className="btn btn-outline-primary position-relative"
                    to={{ pathname: "Filter", search: location.search }}
                    replace
                >
                    Filter
                    {onFilter ? (
                        <span
                            children="on"
                            className="badge text-bg-primary position-absolute top-0 start-100 translate-middle"
                            style={{ minWidth: "2.4em" }}
                        />
                    ) : null}
                </Link>
                <Link
                    children="Export"
                    className="btn btn-outline-primary ms-3"
                    to={{ pathname: "Export", search: location.search }}
                />
                <Link children="Add" className="btn btn-outline-primary float-end" to="Add" />
            </div>
            {!works.length ? (
                <div className="cssLoading">Empty</div>
            ) : (
                <div className="table-responsive">
                    <table className="table">
                        <thead className="noTableTopBorder">
                            <tr>
                                <th>Project</th>
                                <th>Category</th>
                                <th>Location</th>
                                <th>Start</th>
                                <th>End</th>
                                <th>Supervisor</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {works.map((work: Work) => (
                                <tr key={work.id}>
                                    <td>
                                        {work.projectId ? (
                                            <Link to={`/Projects/${work.projectId}`}>{work.projectName}</Link>
                                        ) : (
                                            work.projectName
                                        )}
                                    </td>
                                    <td>{work.subCategory ? `${work.category} - ${work.subCategory}` : work.category}</td>
                                    <td>
                                        {work.location ? (
                                            <a
                                                href={work.coords ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(work.coords)}` : undefined}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {work.location}
                                            </a>
                                        ) : null}
                                    </td>
                                    <td>{work.startTime}</td>
                                    <td>{work.endTime}</td>
                                    <td><UserInfo id = {work.supervisorId} name = {work.supervisorName} /></td>
                                    <td>
                                        <Link children="Detail" className="btn btn-outline-primary" to={String(work.id)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total > 0 ? <ServerFooter length={total} /> : null}
            <Outlet />
        </div>
    );
}
